import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ITimeEntry } from "src/app/timetracking/models/ITimeEntry";
import { TimetrackingService } from "src/app/timetracking/timetracking.service";

@Component({
  selector: "app-calendar-day-edit",
  templateUrl: "./calendar-day-edit.component.html",
  styleUrls: ["./calendar-day-edit.component.scss"],
})
export class CalendarDayEditComponent implements OnInit, AfterViewInit {
  @Input() timeEntry!: ITimeEntry;
  @ViewChild("quickTimeInput", { static: false }) inputEl!: ElementRef<HTMLInputElement>;

  @Output() submitEdit = new EventEmitter<void>();
  @Output() cancelEdit = new EventEmitter<void>();

  quickEditForm!: FormGroup;

  get hoursControl() {
    return this.quickEditForm.controls.hours;
  }

  constructor(
    private fb: FormBuilder,
    private timeTrackingService: TimetrackingService
  ) {}

  ngOnInit() {
    this.buildForm();
  }

  ngAfterViewInit() {
    setTimeout(() => this.inputEl.nativeElement.focus());
  }

  submitClicked() {
    const raw: string = this.hoursControl.value;
    const entry: ITimeEntry = { ...this.timeEntry };
    entry.timeSpentMinutes = this.getTotalMinutes(raw);

    this.timeTrackingService.saveTimeEntry(entry).subscribe(
      () => this.submitEdit.emit(),
      () => alert("Error saving time entry. Please try again or report to AD team.")
    );
  }

  cancelClicked() {
    this.cancelEdit.emit();
  }

  onEnterPressed(event: KeyboardEvent) {
    event.preventDefault();
    this.submitClicked();
  }

  onHoursBlur() {
    const control = this.hoursControl;
    const inputEl = this.inputEl.nativeElement;
    let val: string = control.value || "";

    val = val.replace(/[^\d:]/g, "");
    let [h = "", m = ""] = val.split(":");

    if (h.length === 1) h = "0" + h;
    else if (h.length === 0) h = "00";
    else if (h.length > 2) h = h.slice(0, 2);

    if (m.length === 0) m = "00";
    else if (m.length === 1) m = m + "0";
    else if (m.length > 2) m = m.slice(0, 2);

    const hours = Math.min(23, parseInt(h, 10));
    const minutes = Math.min(59, parseInt(m, 10));

    const newVal = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

    const cursorPos = newVal.indexOf(":") + 1;

    control.setValue(newVal, { emitEvent: true });

    setTimeout(() => inputEl.setSelectionRange(cursorPos, cursorPos));
  }

  onHoursInput() {
    const control = this.hoursControl;
    const inputEl = this.inputEl.nativeElement;
    let val: string = control.value || "";

    if (val.length > 1) return;

    val = val.replace(/[^\d:]/g, "");

    if (!val.includes(":")) {
      const firstDigit = val.charAt(0);
      if (firstDigit && parseInt(firstDigit, 10) > 2) {
        val = "0" + val;
      }
    }

    control.setValue(val, { emitEvent: false });

    setTimeout(() => {
      const pos = val.length;
      inputEl.setSelectionRange(pos, pos);
    });


  }

  private buildForm() {
    const totalMinutes = this.timeEntry.timeSpentMinutes;
    const hours = this.padNumber(Math.floor(totalMinutes / 60));
    const minutes = this.padNumber(totalMinutes % 60);

    this.quickEditForm = this.fb.group({
      hours: [`${hours}:${minutes}`, Validators.pattern(/\d{2}:\d{2}/)],
    });
  }

  private padNumber(num: number): string {
    return ("00" + num).slice(-2);
  }

  private getTotalMinutes(formattedString: string): number {
    const parts = formattedString.split(":");
    const hours = parseInt(parts[0], 10) || 0;
    const minutes = parseInt(parts[1], 10) || 0;
    return hours * 60 + minutes;
  }
}
